import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';
const OpportunityRatingInput = () => {
  const { ratingId = '' } = useParams();
  const decodedId = ratingId ? atob(ratingId) : ratingId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityRating';

  useEffect(() => {
    if (ratingId) { setIsEditing(true); fetchDetails(); }
  }, [ratingId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['opportunityRating'] + id + '/', { headers });
      const d = response.data?.data ?? response.data;
      setFormData({
        ...d,
        opportunity: d.opportunity?.id ?? d.opportunity,
      });
    } catch (error) { console.error('Error fetching Opportunity Rating details:', error); }
  };

  const fields = [
    {
      name: 'opportunity',
      label: 'Opportunity',
      type: 'async-select',
      required: true,
      endpoint: API_ROUTES.opportunity,
      getOptionLabel: (o) => o.opportunity_name || `Opportunity #${o.id}`,
    },
    {
      name: 'rating',
      label: 'Rating',
      type: 'select',
      required: true,
      options: [
        { value: 1, label: '1 - Poor' },
        { value: 2, label: '2 - Fair' },
        { value: 3, label: '3 - Good' },
        { value: 4, label: '4 - Very Good' },
        { value: 5, label: '5 - Excellent' },
      ],
    },
    {
      name: 'comment',
      label: 'Comment',
      type: 'textarea',
    },
    {
      name: 'name',
      label: 'Name (Optional)',
      type: 'text',
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Rating' : 'Create Opportunity Rating'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} cancelPath="/opportunity/rating/list" />
    </div>
  );
};

export default OpportunityRatingInput;